export const EmptyListDefProps = {
  emptyListLabel: 'новое финусловие'
};